module.exports = __webpack_public_path__ + "img/map.6b1daf63.svg";